function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M37.167 14.5v9.167m-17.5-5L3 9.5 19.667 2l16.666 7.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.167 11.792v14.375c0 3.221 5.596 5.833 12.5 5.833 6.903 0 12.5-2.612 12.5-5.833V11.792"
}));

function SvgStudy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 33"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOSAzMyI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTM3LjE2NyAxNC41djkuMTY3TTE5LjY2NyAxOC42NjdMMyA5LjUgMTkuNjY3IDJsMTYuNjY2IDcuNXoiLz48cGF0aCBkPSJNNy4xNjcgMTEuNzkydjE0LjM3NWMwIDMuMjIxIDUuNTk2IDUuODMzIDEyLjUgNS44MzMgNi45MDMgMCAxMi41LTIuNjEyIDEyLjUtNS44MzNWMTEuNzkyIi8+PC9nPjwvc3ZnPg==";
export { SvgStudy as ReactComponent };